module.exports = __webpack_public_path__ + "img/alumni-bg3.d1f290ba.svg";